import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import RoleTabs from './RoleTabs.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateRoles',
  setup(__props) {

    const form = useForm({
        name: '',
        display_name: '',
        description: '',
        is_client: 0,
        permission_ids: [],
        role_company_ids: [],
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.roles.store'),
    "query-key": [_unref(QueryKey).ROLES],
    title: "roles.create",
    "button-text": "roles.create",
    "modal-size": "sm:max-w-3xl"
  }, {
    default: _withCtx(() => [
      _createVNode(RoleTabs, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})